import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class FeatureFlags {
  isFeatureEnabled(feature: Features): boolean {
    if (!environment.features) {
      return false;
    }

    return !!environment.features[feature];
  }
}

export enum Features {
  AlloyUpdate = "AlloyUpdate",
  PushToAlloy = "PushToAlloy",
  AuditLog = "AuditLog",
  ApplicantPushMenu = "ApplicantPushMenu",
  PushToOlb = "PushToOlb",
  Campaign = "Campaign"
}
